import { Grid2 as Grid } from '@mui/material';
import { CurrencyInput, TextInput } from 'framework/form';
import React from 'react';
import BillingRequestFormPeriodicBase from './BillingRequestFormPeriodicBase';

const BillingRequestFormPeriodicPrepaid = ({ isUpdate }: { isUpdate?: boolean }) => {
  return (
    <BillingRequestFormPeriodicBase
      isUpdate={isUpdate}
      commonFieldSize={3}
      renderExtraFields={({ item, index, inApprovalStatus }) => (
        <>
          <Grid size={2}>
            <TextInput
              source={`data.${index}.plannedRegularHours`}
              label="Planned regular hours"
              disabled={inApprovalStatus}
            />
          </Grid>
          <Grid size={2.5}>
            <TextInput
              source={`data.${index}.plannedOvertimeHours`}
              label="Planned overtime hours"
              disabled={inApprovalStatus}
            />
          </Grid>
          <Grid size={2.5}>
            <TextInput
              source={`data.${index}.previousPeriodAdjustmentHours`}
              label="Previous period adjustment hours"
              disabled={inApprovalStatus}
            />
          </Grid>
          <Grid size={2}>
            <CurrencyInput
              label="Total amount"
              source={`data.${index}.amount`}
              suffix={item.currency || ''}
              isControlledValue
              disabled={inApprovalStatus}
            />
          </Grid>
        </>
      )}
    />
  );
};
export default BillingRequestFormPeriodicPrepaid;
